// extracted by mini-css-extract-plugin
export default {"logout":"logout-icon_logout__BJFQ7"};